import { createAsyncThunk } from "@reduxjs/toolkit";
import NotifyConfig from "../../utils/NotifyConfig";
import DashboardService from "../services/dashboardService";

export const DashboardThunk = createAsyncThunk("dashboard/get", async () => {
  try {
    const response = await DashboardService.getDashboard();

    return response;
  } catch (err) {
    NotifyConfig.notifyErrorServer(err.response?.data?.error?.text);
    console.error(err);
  }
});
